import { UserMaintenanceRoutes } from 'src/app/core/enums/routes.enum';

export function getLinkToMaintenanceJobDetails(componentId: string, jobId: string): string {
  return UserMaintenanceRoutes.JobOverview.replace(':id', jobId).replace(
    ':componentId',
    componentId
  );
}
